import React from "react";
import { Link } from "react-router-dom";

const AdminSidebar = ({
  sidebarOpen,
  setSidebarOpen
}) => {
  return (
    <div
      className={`admin-sidebar ${sidebarOpen ? "show-sidebar" : ""
        }`}
    >

      <h2>Admin Panel</h2>

      <Link
        to="/admin/dashboard"
        onClick={() => setSidebarOpen(false)}
      >
        Dashboard
      </Link>
      <Link
        to="/admin/birthday"
        onClick={() => setSidebarOpen(false)}
      >
        Birthday
      </Link>
      <Link
        to="/admin/slider"
        onClick={() => setSidebarOpen(false)}
      >
        Slider
      </Link>
      <Link
        to="/admin/academics"
        onClick={() => setSidebarOpen(false)}
      >
        Academics
      </Link>
      <Link
        to="/admin/galleryAwards"
        onClick={() => setSidebarOpen(false)}
      >
        Gallery & Awards
      </Link>
      <Link
        to="/admin/notice"
        onClick={() => setSidebarOpen(false)}
      >
        Notice
      </Link>
      <Link
        to="/admin/student-work"
        onClick={() => setSidebarOpen(false)}
      >
        Student Work
      </Link>
      <Link
        to="/admin/event"
        onClick={() => setSidebarOpen(false)}
      >
        Event
      </Link>
      <Link
        to="/admin/news"
        onClick={() => setSidebarOpen(false)}
      >
        News
      </Link>
      <Link
        to="/admin/gallery-album"
        onClick={() => setSidebarOpen(false)}
      >
        Gallery
      </Link>
      <Link
        to="/admin/uploadDocuments"
        onClick={() => setSidebarOpen(false)}
      >
        Upload Document
      </Link>
      <Link
        to="/admin/cbse"
        onClick={() => setSidebarOpen(false)}
      >
        CBSE Document
      </Link>
      <Link
        to="/admin/mpd"
        onClick={() => setSidebarOpen(false)}
      >
        Mandatory Public Disclosure
      </Link>
      <Link
        to="/admin/adminstudent-tc"
        onClick={() => setSidebarOpen(false)}
      >
        Student TC
      </Link>
      <Link
        to="/admin/admin-tour"
        onClick={() => setSidebarOpen(false)}
      >
        Virtual Tour
      </Link>
      <Link
        to="/admin/password"
        onClick={() => setSidebarOpen(false)}
      >
        Change Password
      </Link>

    </div>
  );
};

export default AdminSidebar;